import React from 'react';
import { useAuthDebug } from '@/features/auth/hooks/useAuthDebug';

interface AuthDebugPanelProps {
  show?: boolean;
}

export const AuthDebugPanel: React.FC<AuthDebugPanelProps> = ({ show = false }) => {
  const { debugInfo } = useAuthDebug();

  if (!show) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
      <h3 className="text-sm font-bold mb-2">🔍 Auth Debug</h3>
      <div className="space-y-1 text-xs">
        <div className="flex justify-between">
          <span>Token:</span>
          <span className={debugInfo.hasToken ? 'text-green-400' : 'text-red-400'}>
            {debugInfo.hasToken ? '✅ Available' : '❌ Not available'}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Expired:</span>
          <span className={debugInfo.isExpired ? 'text-red-400' : 'text-green-400'}>
            {debugInfo.isExpired ? '❌ Yes' : '✅ No'}
          </span>
        </div>
        {debugInfo.tokenPreview && (
          <div className="flex justify-between">
            <span>Preview:</span>
            <span className="text-yellow-400 font-mono">{debugInfo.tokenPreview}</span>
          </div>
        )}
        <div className="text-gray-400 text-xs mt-2">
          Last check: {debugInfo.lastChecked.toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
}; 